// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607100033/js/" + chunkId + "." + {"44":"aa4fda69","225":"7f3c138b","481":"c81e84cd","486":"65f5bf73","770":"598955da"}[chunkId] + ".0.04814242065020491.chunk.js";
};